import Vue from "vue";
import VueI18n from "vue-i18n";
import BootstrapVue from "bootstrap-vue";
import VueMouseParallax from "vue-mouse-parallax";
import VueScrollTo from "vue-scrollto";
import * as VueGoogleMaps from "vue2-google-maps";
import CKEditor from "@ckeditor/ckeditor5-vue";
import "@ckeditor/ckeditor5-build-classic/build/translations/ru";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from "./layouts/App.vue";
import router from "./router";
import store from "./store";
import user from "./user";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(user);
Vue.use(BootstrapVue);
Vue.use(CKEditor);
Vue.use(VueMouseParallax);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

library.add(fas, far);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA7wmgVer_iqiRzyl8upHsiWKScwUAfV6Q",
    libraries: "places",
    language: "ru"
  },
  installComponents: true
});

const locales = {
  ru: "",
  uk: "",
  eng: "",
  pl: "",
  de: ""
};

const messages = {
  ru: {
    signIn: "Вход",
    done: "Войти",
    close: "Закрыть",
    navigation: "Навигация",
    more: "Подробнее...",
    nav: {
      main: "Главная",
      about_us: "О нас",
      projects: "Реализованные проекты",
      references: "Референции",
      licenses_and_certificates: "Лицензии и сертификаты",
      news: "Новости",
      contact: "Контакты"
    },
    main_page: {
      qualitatively: "КАЧЕСТВЕННО И В СРОК",
      title: "ООО «СТРОИТЕЛЬНАЯ КОМПАНИЯ.»",
      description: `<p>
                      Основано в 1999 году выходцами из ДСУ-101 трест «Днепростальконструкция». Предприятие имеет следующие сертификаты: EN
                      ISO 3834-2, 161216-EN 1090-W-031 WELDING, 1922 CPR-0811, ISO 9001: 2015, а так же УкрСЕПРО.
                    </p>
                    <p>Качественное производственное оборудование и квалифицированный персонал завода ООО «СТРОИТЕЛЬНАЯ КОМПАНИЯ.»
                    обеспечивают полный производственный цикл <span>СТРОИТЕЛЬНЫХ</span> и <span>МОСТОВЫХ</span> металлоконструкций.</p>
                    <p>
                      Основным видом металлоконструкций, производимый компанией является - сварные конструкции двутаврового сечения, в том числе на фланцевых соединениях.
                    </p>
                    <p>
                      Производственные мощности предприятия позволяют
                      изготавливать 500.00тн металлоконструкций ежемесячно.
                    </p>
                    <p>
                      Монтаж металлоконструкций ведется собственным подразделением
                      численностью - 98 сотрудников, включая ИТР.
                    </p>
                    <p>
                      Предприятие имеет большой опыт выполнение работ для
                      МЕЖДУНАРОДНЫХ КОМПАНИЙ, которые работают в разных сферах
                      экономики и предъявляют особые требования к изготовлению и
                      монтажу металлоконструкций.
                    </p>
                    <p>
                      На предприятии имеется собственная монтажная техника, краны башенные: Liebherr 45 EC – одна единица, Liebherr 500 НС-20 –
                      одна единица; краны на гусеничном ходу: МКГ-100.1 – одна единица, СКГ 401 – одна единица; МКГ 40 – одна единица, МКГ -
                      25БР – три единицы, кран автомобильный КС 6371 – одна единица.
                    </p>`,
      director: "Павел Малютов",
      d_position: "Исполнительный директор"
    },
    footer: {
      footer_text: `<p>
                      <span>Девиз</span> – это миссия компании, ее
                      внутренний мир.
                    </p>
                    <p>
                      Наш
                      <span>девиз КАЧЕСВЕННО И В СРОК!</span>
                    </p>
                    <p>
                      <span>КАЧЕСТВЕННО</span> – это прилежное выполнение
                      поставленных задач от Заказчика, а так же соблюдение
                      норм и правил проектирования, изготовления и монтажа,
                      с целью исключение рисков связанных с дальнейшей
                      эксплуатацией построенного объекта.
                    </p>
                    <p>
                      <span>В СРОК</span> – мы понимаем, что любое
                      строительство должно как можно раньше начать окупать
                      вложенные в него инвестиции, поэтому мы гарантируем
                      Заказчику выполнение работ в необходимые сроки.
                    </p>
                    <p><span>С уважением</span>,</p>
                    <p>
                      <span>Директор</span>
                    </p>
                    <p>
                      <span>Павел Малютов</span>
                    </p>`
    }
  },
  uk: {
    signIn: "Вхід",
    done: "Увійти",
    close: "Закрити",
    navigation: "Навігація",
    more: "Детальніше...",
    nav: {
      main: "Головна",
      about_us: "Про нас",
      projects: "Реалізовані проекти",
      references: "Референції",
      licenses_and_certificates: "Ліцензії та сертифікати",
      news: "Новини",
      contact: "Контакти"
    },
    main_page: {
      qualitatively: "ЯКІСНО І В ТЕРМІН",
      title: "ТОВ «БУДІВЕЛЬНА КОМПАНІЯ.»",
      description: `<p>
                      Засноване у 1999 році вихідцями з ДСУ-101 трест «Дніпростальконструкція». Підприємство має наступні сертифікати: EN ISO 3834-2, 161216-EN 1090-W-031 WELDING, 1922 CPR-0811, ISO 9001: 2015-го, а також УкрСЕПРО.
                    </p>
                    <p>Якісне виробниче обладнання та кваліфікований персонал заводу ТОВ «БУДІВЕЛЬНА КОМПАНІЯ.» забезпечують повний виробничий цикл БУДІВЕЛЬНИХ і МОСТОВИХ металоконструкцій.</p>
                    <p>
                      Основним видом металоконструкцій, що виробляє компанія є зварні конструкції двотаврового перерізу, у тому числі на фланцевих з&#39;єднаннях.
                    </p>
                    <p>
                      Виробнича потужність підприємства дозволяє виготовляти 500.00тн металоконструкцій щомісяця.
                    </p>
                    <p>
                      Монтаж металоконструкцій ведеться власним підрозділом чисельністю - 98 співробітників, включно з ІТП.
                    </p>
                    <p>
                      Підприємство має великий досвід виконання робіт для МІЖНАРОДНИХ КОМПАНІЙ, які працюють в різних сферах економіки і пред&#39;являють особливі вимоги до виготовлення і монтажу металоконструкцій.
                    </p>
                    <p>
                      На підприємстві є власна монтажна техніка, крани баштові: Liebherr 45 EC - одна одиниця, Liebherr 500 НС-20 - одна одиниця; крани гусеничні: МКГ-100.1 - одна одиниця, СКГ 401 - одна одиниця; МКГ 40 - одна одиниця, МКГ - 25БР - три одиниці, кран автомобільний КС 6371 - одна одиниця.
                    </p>`,
      director: "Павло Малютов",
      d_position: "Директор"
    },
    footer: {
      footer_text: `<p>
                      <span>Девіз</span> - це місія компанії, її внутрішній світ.
                    </p>
                    <p>
                      Наш девіз <span>ЯКІСНО І В ТЕРМІН</span>!
                    </p>
                    <p>
                      <span> ЯКІСНО </span> - це старанне виконання поставлених задач від Замовника, а також дотримання норм і правил проектування, виготовлення і монтажу, з метою виключення ризиків, пов&#39;язаних з подальшою експлуатацією збудованого об&#39;єкта.
                    </p>
                    <p>
                      <span> В ТЕРМІН </span> - ми розуміємо, що будь-яке будівництво має якомога раніше почати окупати вкладені в нього інвестиції, тому ми гарантуємо Замовнику виконання робіт в необхідні терміни.
                    </p>
                    <p> <span> З повагою</span>, </p>
                    <p>
                      <span>Директор</span>
                    </p>
                    <p>
                      <span>Павло Малютов</span>
                    </p>`
    }
  },
  eng: {
    signIn: "Signin",
    done: "Login",
    close: "Close",
    navigation: "Navigation",
    more: "More details",
    nav: {
      main: "Home",
      about_us: "About Us",
      projects: "Implemented projects",
      references: "References",
      licenses_and_certificates: "Licenses and certificates",
      news: "News",
      contact: "Contacts"
    },
    main_page: {
      qualitatively: "Quality and Timeliness",
      title: "LLC «STROITELNAYA COMPANIYA.»",
      description: `<p>
                      Founded in 1999 by members of DSU-101 the trust company “Dniprostalkonstruktsiia” (Dnipro Steel Construction). The company was awarded the following
                      certificates: EN ISO 3834-2, 161216-EN 1090-W-031 WELDING, 1922 CPR-0811, ISO 9001:2015, as well as UkrSEPRO.
                    </p>
                    <p>
                      High-quality production equipment and qualified personnel of the «STROITELNAYA COMPANIYA.» LLC completely ensure cyclical turnaround of bridge and construction metal structures
                    </p>
                    <p>
                      Among the metal structures produced by the Company, above all, are welded structures of I-section as well as on flange joints.
                    </p>
                    <p>
                      The production capacities of the Company allow producing 500.00 tons of metal structures per month.
                    </p>
                    <p>
                      Installation of metal structures is carried out by the Company's own operating force comprised of 98 employees, including engineers and technicians.
                    </p>
                    <p>
                      The Company has extensive experience in performing work for INTERNATIONAL COMPANIES that operate in various sectors of the economy and have special requirements for the production and installation of metal structures.
                    </p>
                    <p>
                      The Company has its own installation equipment, tower cranes: Liebherr 45 EC – one unit, Liebherr 500 HC-20 – one unit; crawler-mounted cranes: МКГ-100.1 –
                      one unit, СКГ 401 – one unit; МКГ 40 – one unit, МКГ – 25БР – three units, truck-mounted crane KС 6371 – one unit.
                    </p>`,
      director: "Pavlo Maliutov",
      d_position: "Director"
    },
    footer: {
      footer_text: `<p>
                      The <span> Motto </span> is a mission of a company that describes its inner world.
                    </p>
                    <p>
                      Our motto is QUALITY AND TIMELINESS!
                    </p>
                    <p>
                      <span>QUALITY</span> means diligent fulfillment of Client's requests, as well as compliance with the norms and rules of designing, manufacturing and installation, with the aim of eliminating the risks associated with the further operation of the constructed facility.
                    </p>
                    <p>
                      <span>TIMELINESS</span> meant, that we understand that any construction should begin to pay back
                      the investments made in it as soon as possible, therefore we guarantee the Client to
                      complete the work on time.
                    </p>
                    <p> <span> Best regards</span>, </p>
                    <p>
                      <span> Director </span>
                    </p>
                    <p>
                      <span> Pavel Malyutov </span>
                    </p>`
    }
  },
  pl: {
    signIn: "Zaloguj się",
    done: "Zaloguj sie",
    close: "Blisko",
    navigation: "Nawigacja",
    more: "Więcej szczegółów",
    nav: {
      main: "Główny",
      about_us: "O nas",
      projects: "Projekty zrealizowane",
      references: "Referencje",
      licenses_and_certificates: "Licencje i certyfikaty",
      news: "Aktualności",
      contact: "Kontakty"
    },
    main_page: {
      qualitatively: "JAKOŚCIOWO I NA CZAS",
      title: "FIRMA BUDOWLANA Sp. z o.o.",
      description: `<p>
                      Założona w 1999 roku przez ludzi z DSU-101 trust „Dnieprostalkonstrukcja” (Dnierpowska Konstrukcja Stalowa).    Firma posiada następujące certyfikaty: EN ISO 3834-2, 161216-EN 1090-W-031 WELDING, 1922 CPR-0811, ISO ISO 9001: 2015, a także UkrSEPRO.
                    </p>
                    <p>
                      Zakład FIRMA BUDOWLANA Sp. z o.o. jest wyposażony we wszystkie niezbędne urządzenia produkcyjne i personel, aby zapewnić pełny cykl produkcyjny do wykonania metalowych konstrukcji budowlanych i mostowych.
                    </p>
                    <p>
                      Podstawowym rodzajem konstrukcji metalowych produkowanych przez firmę są - konstrukcje spawane z dwuteownikiem, w tym połączenia kołnierzowe.
                    </p>
                    <p>
                      Zdolności produkcyjne przedsiębiorstwa pozwalają na miesięczną produkcję 500,00 ton konstrukcji metalowych.
                    </p>
                    <p>
                      Montaż konstrukcji metalowych wykonywany jest przez własny dział składający się z 98 pracowników, w tym inżynierów.
                    </p>
                    <p>
                      Firma posiada bogate doświadczenie w wykonywaniu prac dla FIRM MIĘDZYNARODOWYCH, które działają w różnych sektorach gospodarki i mają specjalne wymagania w zakresie produkcji i montażu konstrukcji metalowych..
                    </p>
                    <p>
                      Przedsiębiorstwo posiada własny sprzęt montażowy, żurawie wieżowe: Liebherr 45 EC - jedna sztuka, Liebherr 500 HC-20 - jedna sztuka, żurawie gąsienicowe: MKG 100.1 - jedna sztuka, SKG 401 - jedna sztuka; MKG 25-BR - trzy sztuki, dźwig samochodowy KС 6371 - jedna sztuka.
                    </p>`,
      director: "Pavlo Maliutov",
      d_position: "Dyrektor"
    },
    footer: {
      footer_text: `<p>
                      <span>Mottem</span> jest misja firmy, jej świat wewnętrzny. Nasze motto <span>JAKOŚCIOWO I NA CZAS</span!
                    </p>
                    <p>
                      <span>JAKOŚCIOWO</span> to sumienne wykonywanie zadań postawionych przez Klienta, a
                      także przestrzeganie norm i zasad projektowania, produkcji i montażu, w celu
                      wyeliminowania ryzyk związanych z dalszą eksploatacją budowanego obiektu..
                    </p>
                    <p>
                      <span>NA CZAS</span> rozumiemy, że każda budowa powinna zacząć jak najwcześniej
                      zwracać się z poniesionych w niej inwestycji, dlatego gwarantujemy Klientowi
                      wykonanie prac na czas.
                    </p>
                    <p> <span>Z szacunkiem</span>, </p>
                    <p>
                      <span>Dyrektor</span>
                    </p>
                    <p>
                      <span>Pavlo Maliutov</span>
                    </p>`
    }
  },
  de: {
    signIn: "Eingang",
    done: "Betreten",
    close: "Schließen",
    navigation: "Navigation",
    more: "Mehr Details",
    nav: {
      main: "Home",
      about_us: "Über uns",
      projects: "Realisierte projekte",
      references: "Referenzen",
      licenses_and_certificates: "Lizenzen und zertifikate",
      news: "News",
      contact: "Kontakte"
    },
    main_page: {
      qualitatively: "Qualitativ und pünktlich",
      title: "BAUGESELLSCHAFT GmbH",
      description: `<p>
                      Gegründet im Jahr 1999 von Mitgliedern der DSU-101 des Trusts „Dniprostalkonstruktsiia“ (Stahlkonstruktion Dnipro). Die Gesellschaft hat die folgenden Zertifikate: EN ISO 3834-2, 161216-EN 1090-W-031 WELDING, 1922 CPR-0811, ISO 9001: 2015 sowie UkrSEPRO.
                    </p>
                    <p>
                      Hochwertige Produktionsanlagen und qualifiziertes Personal der Baugesellschaft GmbH gewährleisten den vollständigen Produktionszyklus von <span>Brücken- und Baumetallkonstruktionen</span>.
                    </p>
                    <p>
                      Zu den von der Gesellschaft hergestellten Metallkonstruktionen zählen vor allem Schweißkonstruktionen mit Doppel-T-Profil inkl. Flanschverbindungen..
                    </p>
                    <p>
                      Die Produktionskapazitäten des Unternehmens ermöglichen die monatliche Produktion von 500,00 Tonnen der Metallkonstruktionen.
                    </p>
                    <p>
                      Die Installation der Metallkonstruktionen erfolgt durch die firmeneigene Belegschaft, die aus 98 Mitarbeitern besteht, darunter Ingenieure und Techniker.
                    </p>
                    <p>
                      Das Unternehmen hat umfangreiche Erfahrung in der Ausführung von Arbeiten für INTERNATIONALE UNTERNEHMEN, die in verschiedenen Wirtschaftsbereichen tätig sind und besondere Anforderungen an die Herstellung und Installation von Metallkonstruktionen stellen.
                    </p>
                    <p>
                      Das Unternehmen verfügt über eine eigene Installationsausrüstung und Turmdrehkrane: Liebherr 45 EC - eine Einheit, Liebherr 500 HC-20 - eine Einheit; Raupenkrane: МКГ-100.1 - eine Einheit, СКГ 401 - eine Einheit; МКГ 40 - eine Einheit, МКГ - 25БР - drei Einheiten, LKW-Kran KС 6371 - eine
                    Einheit.
                    </p>`,
      director: "Pavlo Maliutov",
      d_position: "Dyrektor"
    },
    footer: {
      footer_text: `<p>
                      Das <span>Motto</span> ist eine Mission eines Unternehmens, das seine innere Welt beschreibt.
                    </p>
                    <p>
                      Unser Motto lautet <span>Qualitativ und pünktlich</span>
                    </p>
                    <p>
                      <span>QUALITATIV</span> bedeutet die sorgfältige Erfüllung der Kundenanforderungen sowie die Einhaltung der Normen und Regeln für Bau, Herstellung und Installation mit dem Ziel, die mit dem weiteren Betrieb der gebauten Anlage verbundenen Risiken
                    auszuschließen.
                    </p>
                    <p>
                      <span>PÜNKTLICH</span> bedeutet, dass wir verstehen, dass jeder Bau beginnen sollte, die getätigten Investitionen so früh wie möglich wieder hereinzuholen, daher garantieren wir dem Kunden, dass die Arbeiten pünktlich abgeschlossen werden.
                    </p>
                    <p> <span>Mit freundlichen Grüßen,</span>, </p>
                    <p>
                      <span>Direktor</span>
                    </p>
                    <p>
                      <span>Pavlo Maliutov</span>
                    </p>`
    }
  }
};

const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "ru",
  messages
});

router.beforeEach((to, from, next) => {
  if (to.params.locale !== undefined) {
    if (locales[to.params.locale] !== undefined) {
      if (to.path.slice(-1) !== "/") {
        i18n.locale = to.params.locale;
        next();
      } else {
        store.state.referer =
          location.protocol +
          "//" +
          location.host +
          to.path.substr(0, to.path.length - 1);
        next("/" + to.params.locale + "/301");
      }
    } else {
      next("/" + Object.keys(locales)[0] + "/404");
    }
  } else {
    next("/" + Object.keys(locales)[0]);
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
